<template>
  <page-template
    :img="{
      src: require('@/assets/misja-1050x630.jpg'),
      lazy: require('@/assets/misja-105x63.jpg'),
      caption: 'PODĄŻAMY ZA DZIECKIEM, ABY ODKRYĆ JEGO PRAWDZIWĄ NATURĘ',
    }"
    title="Misja"
  >
    <p>
      Nasze przedszkole oferuje
      <b
        >program wychowania i edukacji oparty na pedagogice dr Marii
        Montessori.</b
      >
      Zgodnie z jej założeniami rozwój dziecka jest naturalnym procesem,
      indywidualnym dla każdej jednostki. Dziecko “buduje” siebie według
      własnego, wewnętrznego planu, którego nadrzędnym celem jest uzyskanie
      samodzielności i niezależności.
    </p>
    <p>
      Celem naszego przedszkola jest stworzenie dzieciom takich warunków, by
      mogły:
    <ul>
      <li>rozwijać się w swoim indywidualnym tempie,</li>
      <li>czerpać satysfakcję z uzyskiwanej samodzielności i niezależności,</li>
      <li>doświadczać radości uczenia się,</li>
      <li>swobodnie komunikować się z innymi</li>
    </ul>
    </p>

    <p>I dlatego w naszym przedszkolu:
    <ul>
      <li><b>podążamy za dzieckiem i szanujemy jego indywidualność</b></li>
      <li><b>rozpoznajemy i realizujemy potrzeby rozwojowe dziecka</b></li>
      <li>
        <b>
          wspieramy samodzielność jako klucz do wiary w siebie i niezależności
        </b>
      </li>
      <li>
        <b>
          umożliwiamy dziecku uczenie się poprzez działanie i doświadczanie
        </b>
      </li>
      <li>
        <b>
          wychowanie opieramy na rozwijaniu motywacji wewnętrznej, a nie na
          karach i nagrodach
        </b>
      </li>
    </ul></p>
  </page-template>
</template>
<script>
import PageTemplate from '../components/PageTemplate.vue';
export default {
  components: { PageTemplate }
}
</script>
